import React from 'react';
import MultipleHideOnlineCoupon from "@/Pages/Coupons/Assets/MultiplePublicCouponsAction/MultipleHideOnlineCoupon";
import MultipleShowOnlineCoupon from "@/Pages/Coupons/Assets/MultiplePublicCouponsAction/MultipleShowOnlineCoupon";
import MultipleUnpublishCoupon from "@/Pages/Coupons/Assets/MultiplePublicCouponsAction/MultipleUnpublishCoupon";

const MultiplePublicCouponsAction = ({checked}) => {
  return (
    <div className='flex'>
      <MultipleShowOnlineCoupon checked={checked}/>
      <MultipleHideOnlineCoupon checked={checked}/>
      <MultipleUnpublishCoupon checked={checked}/>
    </div>
  );
};

export default MultiplePublicCouponsAction;
